var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('div',{staticClass:"hiq-politicians-search__loader",attrs:{"aria-live":"polite"}},[_c('span',{staticClass:"show-for-sr"},[_vm._v("Laddar...")]),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-politicians-search__loader--spinner"},[_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }